


































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { marked } from 'marked'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { AssistenteIAUseCase } from '@/usecases'
import axios, { CancelTokenSource } from 'axios'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

const ChartJsRenderer = {
	props: ['chartScript', 'canvasId'],
	render(h: any) {
		return h('canvas', {
			ref: 'canvas',
			attrs: { id: this['canvasId'] || 'chart', width: 800, height: 400 },
		})
	},
	mounted() {
		if (!(window as any).Chart) {
			const script = document.createElement('script')
			script.src = 'https://cdn.jsdelivr.net/npm/chart.js'
			script.onload = () => (this as any).renderChart()
			document.head.appendChild(script)
		} else {
			(this as any).renderChart()
		}
	},
	methods: {
		renderChart(this: any) {
			let script = this.chartScript
			if (this.canvasId) {
				const regex = new RegExp(`document.getElementById(['"]${this.canvasId}['"])`, 'g')
				script = script.replace(regex, 'canvas')
			}
			new Function('canvas', 'Chart', script)(this.$refs.canvas, (window as any).Chart)
		},
	},
}

interface Mensagem {
  texto: string
  tipo: 'usuario' | 'sistema'
  html?: string
  chartScript?: string
  canvasId?: string
}

@Component({
	components: { ChartJsRenderer },
})
export default class ChatFlutuante extends Vue {
	expandido = false
	fullscreen = false
	novaMensagem = ''
	mensagens: Mensagem[] = []
	carregando = false
	cancelToken: CancelTokenSource | null = null

	assistenteIAUseCase = new AssistenteIAUseCase()

	get isLoggedIn() {
		return UserLoginStore.isLoggedIn
	}

	get podeUtilizarAssistenteIA(){
		return UserLoginStore.permiteRegraDeNegocio('pode-utilizar-assistente-ia')
	}

	async criarNovaThread() {
		await this.assistenteIAUseCase.criarNovaThread()

		this.buscarMensagensAtualizadas()
	}

	async buscarMensagensAtualizadas() {
		this.cancelToken = axios.CancelToken.source()
		const axiosConfig = {
			cancelToken: this.cancelToken.token,
		}

		try {
			this.mensagens = []
			this.carregando = true
			const mensagensAnteriores = await this.assistenteIAUseCase.buscarMensagens(axiosConfig)

			mensagensAnteriores.push({
				role: 'assistant',
				mensagem: 'Olá, sou seu assistente e vou ajudar você com análises detalhadas de dados relacionados a vendas, ' +
					'estoque e giro de produtos nas lojas de varejo de moda que você tem acesso.\n ' +
					'Exemplos do que posso fazer incluem:\n' +
					'- Consultar estoque atualizado por loja, ' +
					'incluindo quantidade disponível, empenhada, por referência, cor, tamanho e estação.\n' +
					'- Analisar vendas e devoluções por período e loja, detalhando valor faturado, ticket médio, ' +
					'quantidade de peças vendidas, entre outros.\n' +
					'- Identificar os produtos mais vendidos, ' +
					'melhores clientes (quando disponível CPF), marcas, categorias e atributos que performam melhor.\n' +
					'- Identificar produtos com maior giro no estoque e cobertura.\n' +
					'- Ajudar na tomada de decisão com base em dados reais, ajudando a otimizar estoque, ' +
					'melhorar vendas e aumentar o faturamento.\n\nSe desejar, posso gerar relatórios em formato ' +
					'tabelado para facilitar sua visualização e interpretação. Basta informar o que deseja analisar ' +
					'ou quais informações específicas precisa.\n',
				dataHoraMensagem: new Date(0),
			})

			this.mensagens = mensagensAnteriores.sort(
				(dataA, dataB) => {
					if (!dataA.dataHoraMensagem) return 1
					if (!dataB.dataHoraMensagem) return -1
					const a = new Date(dataA.dataHoraMensagem).getTime()
					const b = new Date(dataB.dataHoraMensagem).getTime()
					return a - b
				}).map(mensagemAnterior => {
				const chartHtmlMatch = mensagemAnterior.mensagem.match(/<canvas[^>]*id=["']?([\w-]+)["']?[^>]*><\/canvas>[\s\S]*?<script>([\s\S]*?)<\/script>/i)
				if (chartHtmlMatch) {
					const canvasId = chartHtmlMatch[1]
					const chartScript = chartHtmlMatch[2]
					return {
						texto: mensagemAnterior.mensagem,
						tipo: mensagemAnterior.role === 'assistant' ? 'sistema' : 'usuario',
						html: '',
						chartScript,
						canvasId,
					}
				}

				const htmlBlockMatch = mensagemAnterior.mensagem.match(/```html\s*([\s\S]*?)```/i) || mensagemAnterior.mensagem.match(/(<html[\s\S]*?>[\s\S]*?<\/html>)/i)
				if (htmlBlockMatch) {
					const htmlContent = htmlBlockMatch[1] || htmlBlockMatch[0]
					return {
						texto: mensagemAnterior.mensagem,
						tipo: mensagemAnterior.role === 'assistant' ? 'sistema' : 'usuario',
						html: htmlContent,
					}
				}

				return {
					texto: mensagemAnterior.mensagem,
					tipo: mensagemAnterior.role === 'assistant' ? 'sistema' : 'usuario',
					html: marked(mensagemAnterior.mensagem),
				}
			})
		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	@Watch('mensagens')
	onMensagensChange() {
		this.$nextTick(() => {
			const container = this.$refs.messagesContainer as HTMLElement
			if (container) {
				container.scrollTop = container.scrollHeight
			}
		})
	}

	alternarExpandido() {
		this.expandido = !this.expandido

		if (this.fullscreen && !this.expandido) {
			this.fullscreen = false
		}

		if (this.expandido && this.mensagens.length === 0) {
			this.buscarMensagensAtualizadas()
		}
	}

	alternarFullscreen(): void {
		this.fullscreen = !this.fullscreen
		if (this.fullscreen) {
			document.body.style.overflow = 'hidden'
		} else {
			document.body.style.overflow = ''
		}
	}

	async enviarMensagem() {
		if (!this.novaMensagem.trim() || this.carregando) return

		const pergunta = this.novaMensagem.trim()
		this.mensagens.push({
			texto: pergunta,
			tipo: 'usuario',
		})
		this.novaMensagem = ''
		this.carregando = true

		try {
			this.cancelToken = axios.CancelToken.source()

			const params = {
				pergunta: pergunta,
			}
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const resposta = await this.assistenteIAUseCase.perguntar(params, axiosConfig)

			const chartHtmlMatch = resposta.match(/<canvas[^>]*id=["']?([\w-]+)["']?[^>]*><\/canvas>[\s\S]*?<script>([\s\S]*?)<\/script>/i)
			if (chartHtmlMatch) {
				const canvasId = chartHtmlMatch[1]
				const chartScript = chartHtmlMatch[2]
				this.mensagens.push({
					texto: resposta,
					tipo: 'sistema',
					html: '',
					chartScript,
					canvasId,
				})
				return
			}

			const htmlBlockMatch = resposta.match(/```html\s*([\s\S]*?)```/i) || resposta.match(/(<html[\s\S]*?>[\s\S]*?<\/html>)/i)
			if (htmlBlockMatch) {
				const htmlContent = htmlBlockMatch[1] || htmlBlockMatch[0]
				this.mensagens.push({
					texto: resposta,
					tipo: 'sistema',
					html: htmlContent,
				})
				return
			}

			this.mensagens.push({
				texto: resposta,
				tipo: 'sistema',
				html: marked(resposta),
			})
		} catch (error) {
			this.mensagens.push({
				texto: 'Desculpe, ocorreu um erro ao processar sua pergunta. Tente novamente.',
				tipo: 'sistema',
			})
		} finally {
			this.carregando = false
		}
	}
}
